import { useState } from "react";
import ModalWindow from "../../../../../../Components/ModalWindow/ModalWindow";
import ButtonGrid from "../../../Components/ButtonGrid/ButtonGrid";
import BanTimesSCP from "../../../../../../Services/Data/SCP/BanTimesSCP";
import ServerRequests from "../../../../../../Services/Api/ServersRequests.ts";
import { AddToastNotification } from "../../../../../../Services/ToastNotification/ToastNotificationManager.js";
import { GetDateFromTicks, GetTicksFromDate } from "../../../../../../Services/DateManager/DateManager.js";

const AddEditBanModal = ({selectedBan, isIp, hide, serverId}) => {
    const serverRequests = new ServerRequests();

    const [ipOrId, setIpOrId] = useState(selectedBan?.text ? selectedBan.text[1] : "");
    const [reason, setReason] = useState(selectedBan?.text ? selectedBan.text[3] : "");
    const [time, setTime] = useState(null);

    const editPunishment = () => {
        
        if(!ipOrId){
            AddToastNotification("Dodaj Id/IP kary!", 0)
            return;
        }

        if(!time){
            AddToastNotification("Wybierz czas kary!", 0)
            return;
        }

        if(!reason){
            AddToastNotification("Dodaj powód kary!", 0)
            return;
        }

        console.log("time", BanTimesSCP[time].time);

        const banDate = GetDateFromTicks(selectedBan.text[5]);
        const newBanDate = new Date(banDate.getTime() + parseInt(BanTimesSCP[time].time) * 1000 * 60)

        const data = {
            ServerId: serverId,
            Type : isIp ? 1 : 0,
            OldData : selectedBan?.id,
            EditedData : `${selectedBan.text[0]};${ipOrId};${GetTicksFromDate(newBanDate)};${reason};${selectedBan.text[4]};${selectedBan.text[5]}`
        }

        serverRequests.EditPunishment(data, () => {
            hide()
        });
    }

    return (
        <ModalWindow 
            title={selectedBan ? "Edycja Bana" : "Dodanie Bana"}
            minWidth={"40%"}
            content={
                <div className=" mx-2">
                    <div className="modalField">
                        <label>{ (isIp ? "IP": "Id") + (selectedBan ? " [Readonly]" : "") }</label>
                        <input disabled={selectedBan != null} value={ipOrId} onChange={(e) => setIpOrId(e.target.value)} className="input w-[100%]"/>
                    </div>
                    <div className="modalField">
                        <label>Reason</label>
                        <input value={reason} onChange={(e) => setReason(e.target.value)} className="input w-[100%]"/>
                    </div>
                    <div className="modalField">
                        <label>Time</label>
                        <ButtonGrid className={"grid-cols-[repeat(9,4vw)]"} buttons={BanTimesSCP} selected={time} setSelected={setTime}/>
                    </div>
                </div>
            }

            buttons={[
                { Text: selectedBan ? "Edytuj" : "Dodaj", onClick: () => editPunishment()},
                { Text: "Anuluj",  onClick: () => { hide() }, className: "modalSecondaryBtn"}
            ]}
        />
    )
}

export default AddEditBanModal;